import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
} from "App/constants";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const urlGet = LIST_URL_WAREHOUSE.masterGolonganObatPBF.get;
export const urlGetAll = LIST_URL_WAREHOUSE.masterGolonganObatPBF.getAll;
export const urlUpdate = LIST_URL_WAREHOUSE.masterGolonganObatPBF.update;
export const urlCreate = LIST_URL_WAREHOUSE.masterGolonganObatPBF.add;
export const urlDelete = LIST_URL_WAREHOUSE.masterGolonganObatPBF.delete;

export const RESET_STATE_MASTER_GOLONGAN_OBAT = {
  id: "",
  name: "",
  remark: "-",
};

export const getAllMasterGolonganObat = async () => {
  try {
    const api = await instance4.get(urlGetAll);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deleteMasterGolonganObatById = async (id) => {
  try {
    await instance4.post(urlDelete, {
      id,
    });
    return {
      state: true,
      message: "Data berhasil dihapus",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({
  setShowModal,
  formData,
  setFormData,
  setNewData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const add = async () => {
    return instance4.post(urlCreate, {
      ...formData,
    });
  };

  const update = () => {
    return instance4.post(urlUpdate, {
      ...formData,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await add();
          defaultToastSuccess("Berhasil menambah golongan obat");
        } else if (formData.id !== "") {
          await update();
          defaultToastSuccess("Berhasil mengubah golongan obat");
        }
        setNewData();
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_MASTER_GOLONGAN_OBAT);
        setShowModal(false);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${
        formData.id === "" ? "Tambah" : "Update"
      } Golongan Obat Perbekalan Farmasi`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='INFO'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Info'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='REMARK'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='-'
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.state}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
